import React, { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "./Modal";

export default function BillDetails() {
  const { cart } = useSelector((store) => store.product);
  const [openModal, setOpenModal] = useState(false);

  const result = cart.reduce(
    (sum, { quantity, price }) => sum + parseInt(quantity) * parseInt(price),
    0
  );

  return (
    <div>
      {openModal && <Modal controller={setOpenModal} />}
      <div className="billDetailsCard">
        <h4 className="mt-2 mb-8 text-xl font-bold text-center">
          Bill Details
        </h4>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <p>Sub Total</p>
            <p>
              BDT <span className="lws-subtotal">{result}</span>
            </p>
          </div>

          <div className="flex items-center justify-between">
            <p>Discount</p>
            <p>
              BDT <span className="lws-discount">0</span>
            </p>
          </div>

          <div className="flex items-center justify-between">
            <p>VAT</p>
            <p>
              BDT <span className="vat">0</span>
            </p>
          </div>

          <div className="flex items-center justify-between pb-4">
            <p className="font-bold">TOTAL</p>
            <p className="font-bold">
              BDT <span className="lws-total">{result}</span>
            </p>
          </div>
          <button onClick={() => setOpenModal(true)} className="placeOrderbtn">place order</button>
        </div>
      </div>
    </div>
  );
}
